function escapeCsvValue(value) {
  const normalizedValue = value == null ? '' : String(value);

  if (/[",\n]/.test(normalizedValue)) {
    return `"${normalizedValue.replace(/"/g, '""')}"`;
  }

  return normalizedValue;
}

export function downloadCsv(filename, columns, rows) {
  const headerRow = columns.map(column => escapeCsvValue(column.label)).join(',');
  const dataRows = rows.map((row) => (
    columns.map(column => escapeCsvValue(typeof column.value === 'function' ? column.value(row) : row[column.value]))
      .join(',')
  ));

  const csvContent = [headerRow, ...dataRows].join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = objectUrl;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(objectUrl);
}
